export class RateDetail {
  public Address?: string;
  public City?: string;
  public State?: string;
  public PostalCode?: string;
  public PlanType?: string;
  public ContractLength?: string;
  public PricePerTherm?: string;
  public ProductCode?: string;
  public CustomerServiceFee?: string;
}
